import { render, staticRenderFns } from "./DispositivosExtendidoActividad.vue?vue&type=template&id=0d2a8d86&scoped=true&"
import script from "./DispositivosExtendidoActividad.vue?vue&type=script&lang=ts&"
export * from "./DispositivosExtendidoActividad.vue?vue&type=script&lang=ts&"
import style0 from "./DispositivosExtendidoActividad.vue?vue&type=style&index=0&id=0d2a8d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a8d86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0d2a8d86', component.options)
    } else {
      api.reload('0d2a8d86', component.options)
    }
    module.hot.accept("./DispositivosExtendidoActividad.vue?vue&type=template&id=0d2a8d86&scoped=true&", function () {
      api.rerender('0d2a8d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/DetalleVehiculo/DispositivosExtendidoActividad.vue"
export default component.exports